import dynamic from 'next/dynamic';
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { register } from 'swiper/element/bundle';
import Image from './Image';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

register();

function ImageGallery({ entity, alt, resX, resY, className, style }) {
  const swiperElRef = useRef(null);

  const { image, images } = entity;
  const items = _.isEmpty(images) ? [image] : images;

  useEffect(() => {
    if (!swiperElRef.current) return;
    // listen for Swiper events using addEventListener
    swiperElRef.current.addEventListener('progress', e => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [swiper, progress] = e.detail;
    });
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    swiperElRef.current.addEventListener('slidechange', e => {});
  }, []);

  const params = {
    slidesPerView: 1,
    autoplay: true,
    delay: 5000,
    loop: true,
    pagination: false,
    navigation: true,
  };
  return (
    <swiper-container ref={swiperElRef} {...params}>
      {items.map((x, index) => (
        <swiper-slide key={x}>
          <Image
            src={x}
            alt={alt + index}
            resX={resX}
            resY={resY}
            className={className}
            style={style}
          />
        </swiper-slide>
      ))}
    </swiper-container>
  );
}

ImageGallery.propTypes = {
  entity: PropTypes.object.isRequired,
  alt: PropTypes.string,
  resX: PropTypes.number,
  resY: PropTypes.number.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
};

ImageGallery.defaultProps = {
  alt: '..',
  className: '',
  resX: undefined,
  style: {},
};

export default dynamic(() => Promise.resolve(ImageGallery), {
  ssr: false,
});
